import axios, { AxiosInstance } from "axios";
import { baseAPI } from "@/functions/apibase.function";
import {
  requestHandler,
  responseHandler,
  errorResponseHandler,
} from "@/functions/axioshandler.function";

const instance: AxiosInstance = axios.create({
  baseURL: `${baseAPI}/api/v1/user`,
});
instance.interceptors.request.use(requestHandler);
instance.interceptors.response.use(responseHandler, errorResponseHandler);

export function Base(): AxiosInstance {
  return instance;
}
